import { useEffect, useRef, useState } from 'react';

import type { TtqWorkbenchFocusEmphasis } from './TtqWorkbenchFocusLayout';

/** 分栏侧重状态：首次启用分栏时默认强调左栏 */
export function useTtqWorkbenchFocusEmphasis(split: boolean) {
  const [emphasis, setEmphasis] = useState<TtqWorkbenchFocusEmphasis>('left');
  const hadSplitRef = useRef(false);

  useEffect(() => {
    if (split && !hadSplitRef.current) {
      setEmphasis('left');
    }
    hadSplitRef.current = split;
  }, [split]);

  return { emphasis, setEmphasis };
}
